import { render } from "./AnalysisSection.vue?vue&type=template&id=4fa2fca6"
import script from "./AnalysisSection.vue?vue&type=script&lang=js"
export * from "./AnalysisSection.vue?vue&type=script&lang=js"

import exportComponent from "/chi/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__